export interface IPromoLabel {
  text: string;
  type: EPromoLabelType;
}

export enum EPromoLabelType {
  Mortgage = 'mortgage',
  Discount = 'discount',
  Bonus = 'bonus',
  NewbuildingCount = 'newbuildingCount',
}
